import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setCoach } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setCoach(data);
        // Clear the hash and go to coach dashboard
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Bienvenue ${data.name || "coach"} !`);
        navigate("/coach", { replace: true });
      } catch (e) {
        toast.error(e?.response?.data?.detail || "Échec de la connexion");
        navigate("/", { replace: true });
      }
    })();
  }, [location, navigate, setCoach]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-[#5C6561]">Connexion en cours…</div>
    </div>
  );
}
